var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfflineCloud = function SvgOfflineCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 2.3c-.4-.4-1-.5-1.4-.1s-.5 1-.1 1.4l12 14c.4.4 1 .5 1.4.1s.5-1 .1-1.4zM0 10c0-1.7.8-3.2 2.1-4.1L10 15H5c-2.8 0-5-2.2-5-5m20 1c0 2-1.4 3.6-3.3 3.9L6.3 3.1c.9-.7 2-1.1 3.2-1.1 2.9 0 5.3 2.3 5.5 5.1.3-.1.7-.1 1-.1 2.2 0 4 1.8 4 4"
  })));
};
export default SvgOfflineCloud;